import { render, staticRenderFns } from "./chooseStoreOrderCart.vue?vue&type=template&id=2aa31465&scoped=true"
import script from "./chooseStoreOrderCart.vue?vue&type=script&lang=js"
export * from "./chooseStoreOrderCart.vue?vue&type=script&lang=js"
import style0 from "./chooseStoreOrderCart.vue?vue&type=style&index=0&id=2aa31465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa31465",
  null
  
)

export default component.exports